export default "__VITE_ASSET__D1zDMM$w__"